import { Box, CheckBox, DateInput, FormField, Grid, MaskedInput, Text, TextInput } from "grommet";
import * as React from "react";
import { CreateSeedMatchRequest, SeedMatchViewModel } from "./SeedMatchesStore";

import { format, formatISO, parseJSON, setHours, setMinutes } from "date-fns";
import { format as formatTZ, zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
import { DateTimePicker } from "../components/DateTimePicker";
import { useUser } from "../account/AccountStore";

const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

const SeedMatchDetails = ({ seedMatch, isBusy, onChange }: { seedMatch: SeedMatchViewModel; isBusy: boolean; onChange: Function }) => {
    let [date, setDate] = React.useState(seedMatch.date);
    const [name, setName] = React.useState(seedMatch.name || "");
    const [rounds, setRounds] = React.useState(seedMatch.rounds || 1);

    const [isPublic, setIsPublic] = React.useState(seedMatch.isPublic || false);
    const [archived, setArchived] = React.useState(seedMatch.archived || false);

    React.useEffect(() => {
        onChange({ name, rounds, date, isPublic, archived });
    }, [name, rounds, date, isPublic, archived]);

    return (
        <Box>
            <Grid columns={["1/2", "1/2"]}>
                <Box gap="small">
                    <FormField label="Name">
                        <TextInput value={name} onChange={(e) => setName(e.target.value)} disabled={isBusy} />
                    </FormField>
                    <FormField label="Public">
                        <CheckBox checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} disabled={isBusy} />
                    </FormField>
                    <FormField label="Rounds">
                        <TextInput value={rounds} onChange={(e) => setRounds(+e.target.value)} disabled={isBusy} />
                    </FormField>
                </Box>
                <Box gap="small">
                    <DateTimePicker value={seedMatch.date} disabled={isBusy} onChange={(_date) => setDate(_date)}></DateTimePicker>
                </Box>
            </Grid>
        </Box>
    );
};

export default SeedMatchDetails;
